<template>
  <div class="q-px-md">
    <div
      class="row items-center q-pb-xs justify-between"
      style="height: 30px; width: 100%"
    >
      <div class="text-primary text-weight-bold">{{ sectionData.title }}</div>
      <div
        v-if="sectionData.slides.length > 1"
        style="min-width: 100px; margin-right: -8px"
        class="text-primary row items-center justify-between"
      >
        <q-icon
          class="cursor-pointer"
          @click="$refs.carousel.previous()"
          name="chevron_left"
          size="sm"
        />
        <div class="text-grey-10">
          {{ `${slide + 1}/${sectionData.slides.length}` }}
        </div>
        <q-icon
          class="cursor-pointer"
          @click="$refs.carousel.next()"
          name="chevron_right"
          size="sm"
        />
      </div>
    </div>
    <q-carousel
      ref="carousel"
      animated
      v-model="slide"
      height="200px"
      control-type="outline"
      infinite
    >
      <q-carousel-slide
        v-for="(item, i) in sectionData.slides"
        :key="i"
        :name="i"
        :img-src="`${sectionData.baseUrl}${item.src}`"
      />
    </q-carousel>
    <div v-if="slideTitle" class="text-grey-8 column">
      <h3>{{ slideTitle }}</h3>
      <div style="font-size: 0.8rem" v-html="slideDescription"></div>
    </div>
  </div>
</template>

<script>
import mixin from "../../d-card-mixins";
export default {
  name: "DCarousel",
  mixins: [mixin],
  props: {
    sectionData: {
      type: Object,
      default: () => {},
    },
    storePath: {
      type: String,
      required: true,
    },
    behavior: {
      type: String,
      default: "agent",
    },
  },
  data() {
    return {
      lslide: 0,
    };
  },
  computed: {
    slide: {
      get() {
        if (this.behavior === "agent") {
          return this.lslide;
        } else {
          let data = JSON.parse(this.$cardStore.get(this.storePath));
          if (data.slide === undefined) {
            data.slide = 0;
          }
          return data.slide;
        }
      },
      set(val) {
        if (this.behavior === "agent") {
          this.lslide = val;
        } else {
          this.$cardStore.set(this.storePath, JSON.stringify({ slide: val }));
        }
      },
    },
    slideTitle: {
      get() {
        return this.sectionData.slides[this.slide].title !== undefined
          ? this.sectionData.slides[this.slide].title
          : "";
      },
    },
    slideDescription: {
      get() {
        return this.sectionData.slides[this.slide].description;
      },
    },
  },
};
</script>
